// 添加样式依赖
import '@/common/css/index.scss';
import './index.scss';
// 添加js依赖
import $ from 'zepto-webpack';
import { Url } from '../../common/js/SL-es';

$(() => {
  function GetQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  }

  function is_android() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var os = GetQueryString('os');
    return isAndroid || os == 'Android';
  }

  var btn = document.getElementById('onload');

  btn.onclick = function() {
    let flag = Url.getQueryString('address');
    if (is_android()) {
      let downLoad = flag
        ? 'https://yiqibuduoduo.com/download/walkMonkey_bddbdpx1.apk'
        : 'https://www.yiqibuduoduo.com/apk/buduoduo.apk';
      location.href = downLoad;
    } else {
      location.href = 'https://apps.apple.com/cn/app/walk/id1474052323';
    }
  };
});
